import { notificationsSlice } from './slice';

export const { add, remove } = notificationsSlice.actions;

export { notificationsSlice };
